export default __webpack_public_path__ + "static/media/WHT-HUSD.1e4afe19.png";